<div class="modal fade" id="modal-default">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Add Customer</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                    <form [formGroup]="addCustomerForm" (ngSubmit)="addCustomer()">
                        <div class="form-group">
                          <mat-form-field class="example-full-width">
                            <mat-label>Company</mat-label>
                            <input formControlName="company_name" matInput>
                          </mat-form-field>
                        </div>
                        <div class="form-group">
                          <mat-form-field class="example-full-width">
                            <mat-label>First Name</mat-label>
                            <input formControlName="first_name" matInput>
                          </mat-form-field>
                        </div>
                        <div class="form-group">
                          <mat-form-field class="example-full-width">
                            <mat-label>Last Name</mat-label>
                            <input formControlName="last_name" matInput>
                          </mat-form-field>
                        </div>
                        <div class="form-group">
                          <mat-form-field class="example-full-width" hintLabel="Max 255 characters">
                            <mat-label>Address</mat-label>
                            <input formControlName="address" matInput #input maxlength="255" (input)="onInput($event)" />
                            <mat-hint align="end">{{value().length}}/255</mat-hint>
                          </mat-form-field>
                        </div>
                        <div class="form-group">
                          <mat-form-field class="example-full-width" (touchstart)="onTouch()">
                            <mat-label>Select (Town/City/Village)*</mat-label>
                            <input matInput
                                  (focus)="onTouch()" 
                                   aria-label="State"
                                   [formControl]="stateCtrl"
                                   [matAutocomplete]="auto"
                                   autocomplete="new-password">
                            <mat-icon matSuffix>location_on</mat-icon>
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                              @for (state of filteredStates | async; track state) {
                                <mat-option [value]="state.name" [id]="state.location_id">
                                  <!-- (click)="OnLocationSelected(state)" <img alt="" class="example-option-img" [src]="state.flag" height="25"> -->
                                  <span>{{state.name}}</span> |
                                  <small>Location ID: {{state.location_id}}</small>
                                </mat-option>
                              }
                            </mat-autocomplete>
                                <!-- The Clear mat-icon-button Button -->
                                <button type="button" mat-icon-button *ngIf="stateCtrl.value" matSuffix  aria-label="Clear" (click)="clearInput()">
                                  <mat-icon>close</mat-icon>
                                </button>
                          </mat-form-field>
                          <br>
                        </div>
                        <div class="form-group">
                          <mat-form-field>
                            <mat-label>Phone number</mat-label>
                            <input matInput
                                    type="text" 
                                    minlength="7" 
                                    maxlength="7" 
                                    inputmode="numeric" 
                                    pattern="[0-9]*"
                                    oninput=" this.value = this.value.replace(/[^0-9]/g,'')"
                                    formControlName="mobile"
                                    (blur)="updateErrorMessage2()"
                                    required>
                            <mat-icon matSuffix>phone</mat-icon>
                            @if (mobile.invalid) {
                              <mat-error>{{errorMessage2()}}</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="form-group">
                          <mat-form-field class="example-full-width">
                            <mat-label>Email</mat-label>
                            <input
                              matInput
                              placeholder="nk@example.com"
                              formControlName="email"
                              (blur)="updateErrorMessage()"
                            />
                            <mat-icon matSuffix>email</mat-icon>
                              <!-- required -->
                            @if (email.invalid) {
                              <mat-error>{{errorMessage()}}</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="modal-footer justify-content-between">
                          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                          <button type="submit" mat-flat-button color="primary" [disabled]="addCustomerForm.invalid">Add Customer</button>
                        </div>
                    </form>
                  </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
</div>